import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Directive({
	selector: '[smTranslate]',
})
export class SmTranslateDirective implements AfterContentInit {
	private _def: string;
	@Input('smTranslate') key: string;

	constructor(private _el: ElementRef, private _translationService: TranslationService) { }

	ngAfterContentInit(): void {
		this._def = this._el.nativeElement.innerHtml;
		this._el.nativeElement.innerHtml = this._translationService.getString(this._def);
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/directives/sm-translate.directive.ts